import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { DummySiteComponent } from '@site-info';
import {
    TenantListComponent,
    TenantEditBasicDataComponent,
    TenantEditAllPrivilegesComponent,
    TenantEditApiAccountsComponent,
    TenantEditApplicationsInfoMappingComponent,
    TenantEditKeyPerformanceIndicatorComponent,
    TenantEditBillingComponent,
    TenantEditBannedDomainsComponent,
    TenantFromTemplateComponent,
    TenantPlantUsersComponent,
    TenantInactiveUsersComponent,
    TenantSystemNotificationComponent
} from '@tenant';
import { RoutePrivilegeNames } from '@route-privilege-names';
import { TenantEditGuard } from 'modules/tenant-module/administration/tenant-edit-parts/tenant.edit.guard';



export const NewTenantRoutes: Array<RoutingEntry> = [
     {
        path : '',
        component: TenantListComponent,
        data: {
            title: __asyncI18n('Tenants', 'subnavi.administration.tenants'),
            showSubNaviLevel: 1
        }
    },
    {
        path : 'Add',
        component: TenantEditBasicDataComponent,
        data : {
            title : ':intenant | tenantType', //__asyncI18n('Add tenant', 'subnavi.administration.add-tenat'),
            showSubNaviLevel: 1,
            testId: 'administration.tenants.add'
        }
    },
    {
        path : 'AddSub/:tenantid',
        component: DummySiteComponent,
        data : {
            title : __asyncI18n('Add sub-tenant', 'subnavi.administration.add-sub-tenat'),
            showSubNaviLevel: 1,
            redirectTo: 'Administration/Tenants/Add?intenant=:tenantid'
        }
    },
    {
        path : 'CreateFromTemplate',
        component : TenantFromTemplateComponent,
        data : {
            title : __asyncI18n('Create from template', 'subnavi.administration.create-tenant-from-template'),
            contentRoute : '/SystemAdministration/Tenant/CreateTenantFromTemplate?parentId=:parentId',
            showSubNaviLevel: 1,
            testId: 'administration.tenants.create-from-template'
        }
    },
    {
        path : ':selectedtenantid',
        data : {
            title : ':selectedtenantid | tenantIdToName',
            favouritesRouteCaption: '[MainPageName]',
            showParentInSubNavigation: true,
            showChildrenAsSecondLevel: true,
            dontShowInSubNavigation: true,
            redirectTo: [
                'Administration/Tenants/:selectedtenantid/Settings',
                'Administration/Tenants/:selectedtenantid/Privileges',
                'Administration/Tenants/:selectedtenantid/ApplicationInfoMapping',
                'Administration/Tenants/:selectedtenantid/KeyPerformanceIndicator',
                'Administration/Tenants/:selectedtenantid/Billing',
                'Administration/Tenants/:selectedtenantid/BannedDomains'
            ],
        },
        children : [
            {
                path : '',
                component : DummySiteComponent,
                data : {
                    title : ':selectedtenantid | tenantIdToName',
                    showParentInSubNavigation: true,
                    showChildrenAsSecondLevel: true,
                    dontShowInSubNavigation: true,
                    redirectTo: [
                        'Administration/Tenants/:selectedtenantid/Settings',
                        'Administration/Tenants/:selectedtenantid/Privileges',
                        'Administration/Tenants/:selectedtenantid/ApplicationInfoMapping',
                        'Administration/Tenants/:selectedtenantid/KeyPerformanceIndicator',
                        'Administration/Tenants/:selectedtenantid/Billing',
                        'Administration/Tenants/:selectedtenantid/BannedDomains'
                    ]
                }
            },
            {
                path : 'Settings',
                component: TenantEditBasicDataComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Settings', 'subnavi.administration.tenant.settings'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavSetting',
                    testId: 'administration.tenants.accordion.tenant'
                }
            },
            {
                path : 'Privileges',
                component: TenantEditAllPrivilegesComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Privileges', 'subnavi.administration.tenant.privileges'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavPrivileges',
                    testId: 'administration.accordion.privileges'
                }
            },
            {
                path : 'ApiAccount',
                component: TenantEditApiAccountsComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Api Account', 'subnavi.administration.tenant.api-account'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavApiAccounts',
                    testId: 'administration.tenants.accordion.apiaccounts'
                }
            },
            {
                path : 'ApplicationInfoMapping',
                component: TenantEditApplicationsInfoMappingComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Application Info Mapping', 'subnavi.administration.tenant.application-info-mapping'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavApplicationInfo',
                    testId: 'administration.tenants.accordion.default'
                }
            },
            {
                path : 'KeyPerformanceIndicator',
                component: TenantEditKeyPerformanceIndicatorComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Key Performance Indicator', 'subnavi.administration.tenant.key-performance-indicator'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavKpi',
                    testId: 'administration.tenants.accordion.kpis'
                }
            },
            {
                path : 'Billing',
                component: TenantEditBillingComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Billing', 'subnavi.administration.tenant.billing'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.BillingAdmin
                    ],
                    tenantPermission: 'TenantNavBilling',
                    testId: 'administration.tenants.accordion.billing'
                }
            },
            {
                path : 'BannedDomains',
                component: TenantEditBannedDomainsComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Banned domains', 'subnavi.administration.tenant.banned-domains'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavBannedDomains',
                    testId: 'administration.tenants.accordion.banneddomains'
                }
            },
            {
                path : 'PlantUsers',
                component: TenantPlantUsersComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Plant Users', 'subnavi.administration.tenant.plant-users'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    privileges: [
                        RoutePrivilegeNames.TenantManage
                    ],
                    tenantPermission: 'TenantNavBannedDomains',
                    testId: 'administration.tenants.accordion.plant-users'
                }
            },
            {
                path : 'InactiveUsers',
                component: TenantInactiveUsersComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('Inactive Users', 'subnavi.administration.tenant.inactive-users'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    tenantPermission: 'TenantUserInactivityList',
                    testId: 'administration.tenants.accordion.inactive-users'
                }
            },
            {
                path : 'SystemNotification',
                component: TenantSystemNotificationComponent,
                canActivate: [TenantEditGuard],
                data : {
                    title : __asyncI18n('System Notifications', 'subnavi.administration.tenant.system-notification'),
                    favouritesTitle: '[ParentParentPageName]',
                    favouritesCaption: '[ParentPageName] / [PageName]',
                    tenantPermission: 'SystemNotificationsTenantOverride',
                    testId: 'administration.tenants.accordion.system-notifications'
                }
            }
        ]
    }
];
